/**
 * Portal API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { observable, action, runInAction } from 'mobx';
import { inject, injectable, optional } from 'inversify';
import axios, { AxiosPromise, AxiosRequestConfig } from 'axios';

import { VisitActionRequest } from '../model/visitActionRequest';

import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration, ErrorStatusMap, ExtraAxiosConfig } from '../configuration';


@injectable()
export class VisitAssistantApiService {

    protected basePath = '';
    protected configuration = new Configuration();

    constructor(@inject(BASE_PATH) @optional() basePath: string, @optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }


    @observable
    public getVisitActionRequestObservable: VisitActionRequest | undefined = undefined;

    /**
     * 
     * 
     * @param visitActionId 
     */
    @action
    public getVisitActionRequest(visitActionId: string, showBusy?: boolean, errorStatusMap?: ErrorStatusMap): AxiosPromise<VisitActionRequest> {
        if (visitActionId === null || visitActionId === undefined) {
            throw new Error('Required parameter visitActionId was null or undefined when calling getVisitActionRequest.');
        }

        const headers: {[index: string]: string} = {};

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        const configWithExtra: AxiosRequestConfig & ExtraAxiosConfig = {
            withCredentials: this.configuration.withCredentials,
            headers,
            showBusy,
            errorStatusMap
        };
        const config = configWithExtra as AxiosRequestConfig;

        return axios.get<VisitActionRequest>(
            `${this.basePath}/api/visit-assistant/${encodeURIComponent(String(visitActionId))}`,
            config
        ).then(response => {
            if (response.data) {
                runInAction(() =>  this.getVisitActionRequestObservable = response.data);
            }
            return response;
        });
    }

}
